import { Result, Uuid } from '@standardnotes/domain-core';
import { HttpStatusCode } from '@standardnotes/responses';
export class DesignateSurvivor {
    constructor(sharedVaultUserServer) {
        this.sharedVaultUserServer = sharedVaultUserServer;
    }
    async execute(dto) {
        const sharedVaultUuidOrError = Uuid.create(dto.sharedVaultUuid);
        if (sharedVaultUuidOrError.isFailed()) {
            return Result.fail(sharedVaultUuidOrError.getError());
        }
        const sharedVaultUuid = sharedVaultUuidOrError.getValue();
        const sharedVaultMemberUuidOrError = Uuid.create(dto.sharedVaultMemberUuid);
        if (sharedVaultMemberUuidOrError.isFailed()) {
            return Result.fail(sharedVaultMemberUuidOrError.getError());
        }
        const sharedVaultMemberUuid = sharedVaultMemberUuidOrError.getValue();
        const response = await this.sharedVaultUserServer.designateSurvivor({
            sharedVaultUuid,
            sharedVaultMemberUuid,
        });
        if (response.status !== HttpStatusCode.Success) {
            return Result.fail('Failed to mark designated survivor on the server');
        }
        return Result.ok();
    }
}
